export enum ProductAITabValue {
  Prompt = 0,
  Template,
  Keywords,
  History,
}
